// extracted by mini-css-extract-plugin
export default {"ListTitle":"EmployerList_ListTitle__csOIn"};